/*******************************************************************************
 *                                                                             *
 * WARNING! This file was automatically generated from the server-side model!  *
 * You shouldn't edit this by hand.  If you want to modify the client-side     *
 * model behavior, you should modify: ../ModelReportProperty.ts                *
 *                                                                             *
/*******************************************************************************/

import { Endpoint, ModelRow, RowConstructor } from "@mcleod/core";

const endpointPath = "lme/general/report-property";

export class AutogenModelReportProperty<RowType extends ModelRow> extends Endpoint<RowType, RowReportPropertyFields> {
	constructor(ctor: RowConstructor) {
		super(endpointPath, ctor);
	}
}

export class AutogenRowReportProperty extends ModelRow<RowReportPropertyFields> {
	constructor(values?: Partial<RowReportPropertyFields>) {
		super(endpointPath, true, values);
	}
}

export interface RowReportPropertyFields {
	company_id: string;
	id: string;
	imaging_doc_type: string;
	imaging_file_type: string;
	is_active: string;
	print_action: string;
}

